import React from 'react';
import { cn } from '../../design-system/cn';
import { radii } from '../../design-system/tokens';

const SIZES = {
  xs: `w-7 h-7 ${radii.control} text-[10px]`,
  sm: `w-9 h-9 ${radii.control} text-xs`,
  md: `w-12 h-12 ${radii.card} text-sm`,
  lg: `w-14 h-14 ${radii.card} text-base`,
};

function initialsFrom(name) {
  if (!name) return '?';
  const parts = String(name).trim().split(/\s+/).slice(0, 2);
  return parts.map((p) => p[0]?.toUpperCase() || '').join('') || '?';
}

/**
 * Avatar — rounded-square user image with fallback (initials or custom node).
 * Consolidates the inline `<img object-cover>` avatar markup used across
 * Friends/FindOps/LiveGameWager and similar lists. Border/ring treatment is
 * passed via className so callers keep their own accent.
 */
export default function Avatar({
  src,
  name,
  alt,
  size = 'md',
  fallback,
  className,
  ...props
}) {
  return (
    <span
      className={cn(
        'inline-flex items-center justify-center shrink-0 overflow-hidden bg-gray-800 font-black uppercase text-gray-300',
        SIZES[size] || SIZES.md,
        className
      )}
      {...props}
    >
      {src ? (
        <img src={src} alt={alt ?? name ?? ''} className="w-full h-full object-cover" />
      ) : (
        fallback ?? <span aria-hidden>{initialsFrom(name)}</span>
      )}
    </span>
  );
}
